<template>
  <div>
    <div class="mb-4">
      <div class="flex items-center border-b border-b-2 border-blue-darker py-2">
        <input class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2 leading-tight" type="text" placeholder="Title" aria-label="Full name" :value="content.title" @input="$store.commit('SET_CONTENT_TITLE', $event.target.value)">
      </div>
    </div>
    <div v-if="content.hero.enabled" class="mb-4" :class="{dark: froalaHeroDark}">
      <h5 class="pb-1 pl-2">
        Hero Image Content
        <span @click="froalaHeroDark = !froalaHeroDark" class="text-xs font-thin cursor-pointer">(toggle editor background)</span>
      </h5>
      <froala :tag="'textarea'" :config="config" :value="content.hero.body" @input="$store.commit('SET_CONTENT_HERO_BODY', $event)"></froala>
    </div>
    <div class="mb-4">
      <h5 v-if="content.hero.enabled" class="pb-1 pl-2">Main Page Content</h5>
      <div v-if="froalaLoading">Loading ...</div>
      <froala v-else :tag="'textarea'" :config="config" :value="content.body" @input="$store.commit('SET_CONTENT_BODY', $event)"></froala>
    </div>
    <div class="flex flex-col md:flex-wrap md:flex-row">
      <div class="flex-1 p-4 border border-grey-lighter rounded mr-0 md:mr-2">
        <label class="text-grey-darker text-lg font-bold mb-2" for="clean-url">
          Navigation
        </label>
        <label class="block text-grey font-bold py-2">
          <input class="mr-2 leading-tight" type="checkbox" :checked="content.navigationItem.enabled" @input="$store.commit('SET_CONTENT_NAVIGATION_ITEM_ENABLED', $event.target.checked)">
          <span class="text-sm">
            create menu item
          </span>
        </label>
        <label class="text-grey-darker text-sm font-bold mb-2" for="clean-url">
          Parent
        </label>
        <div class="relative p-2">
          <select id="grid-state" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded leading-tight" :disabled="!content.navigationItem.enabled" :value="content.navigationItem.parent_id" @input="$store.commit('SET_CONTENT_NAVIGATION_ITEM_PARENT', $event.target.value)">
            <option></option>
            <option v-for="(link, key) in navigation" :value="key" :key="key">
              {{ link }}
            </option>
          </select>
          <div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
          </div>
        </div>
        <div class="flex items-center border-b border-b-2 border-blue-darker py-2">
          <input :class="{ 'text-grey': !content.navigationItem.enabled}" :value="content.navigationItem.text" :disabled="!content.navigationItem.enabled" placeholder="Link text" type="text" class="appearance-none bg-transparent border-none w-full text-grey-darker" aria-label="Path" @input="$store.commit('SET_CONTENT_NAVIGATION_ITEM_TEXT', $event.target.value)">
        </div>
        <div class="flex items-center border-b border-b-2 border-blue-darker py-2">
          <input :class="{ 'text-grey': !content.navigationItem.enabled}" :value="content.navigationItem.icon" :disabled="!content.navigationItem.enabled" placeholder="Icon class(es)" type="text" class="appearance-none bg-transparent border-none w-full text-grey-darker" aria-label="Path" @input="$store.commit('SET_CONTENT_NAVIGATION_ITEM_ICON', $event.target.value)">
        </div>
      </div>
      <div class="flex-1 p-4 mt-4 md:mt-0 border border-grey-lighter rounded ml-0 md:ml-2">
        <label class="text-grey-darker text-lg font-bold mb-2" for="clean-url">
          Path
        </label>
        <label class="block text-grey font-bold py-2">
          <input :checked="content.urlAlias.auto" class="mr-2 leading-tight" type="checkbox" @input="$store.commit('SET_CONTENT_URL_ALIAS_AUTO', $event.target.checked)">
          <span class="text-sm">
            automatically generated
          </span>
        </label>
        <div class="flex items-center border-b border-b-2 border-blue-darker py-2 mb-6">
          <input :class="{ 'text-grey': content.urlAlias.auto}" class="appearance-none bg-transparent border-none w-full text-grey-darker" :value="content.urlAlias.path" :disabled="content.urlAlias.auto" placeholder="clean-url" type="text" aria-label="Path" @input="$store.commit('SET_CONTENT_URL_ALIAS_PATH', $event.target.value)">
        </div>
        <label class="text-grey-darker text-lg font-bold mb-2" for="clean-url">
          Hero page
        </label>
        <label class="block text-grey font-bold py-2">
          <input :checked="content.hero.enabled" class="mr-2 leading-tight" type="checkbox" @input="$store.commit('SET_CONTENT_HERO_ENABLED', $event.target.checked)">
          <span class="text-sm">
            enable hero image
          </span>
        </label>
        <div class="flex items-center border-b border-b-2 border-blue-darker py-2">
          <input :class="{ 'text-grey': content.hero.enabled}" class="appearance-none bg-transparent border-none w-full text-grey-darker" :value="content.hero.image" :disabled="!content.hero.enabled" placeholder="hero image URL" type="text" aria-label="Path" @input="$store.commit('SET_CONTENT_HERO_IMAGE', $event.target.value)">
        </div>
      </div>
      <div class="flex lg:flex-1 mt-4 lg:mt-0 justify-end self-start md:flex-none w-full">
        <button :class="buttonState" class="flex-no-shrink bg-blue-dark hover:bg-blue-darker border-blue-dark hover:border-blue-darker text-sm border-4 text-white py-1 px-2 rounded" type="button" @click="saveContent()">
          {{ saveButtonText }}
        </button>
        <button class="flex-no-shrink border-transparent border-4 text-blue-dark hover:text-blue-darkest text-sm py-1 px-2 rounded" type="button" @click="$router.push('/content')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { api } from "arctic-vuejs-template";

export default {
  name: "content-edit",
  props: {
    id: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      config: {
        charCounterCount: false,
        events: {
          "froalaEditor.initialized": () => {
            console.log("initialized");
          },
        },
        fileMaxSize: 1024 * 1024 * 150,
        fileUploadURL: "https://assets.tradeway.com/",
        fontFamily: {
          "TimesNewRoman, 'Times New Roman', Times, Baskerville, Georgia, serif": "Times New Roman",
          "Arial, 'Helvetica Neue', Helvetica, sans-serif": "Arial"
        },
        heightMin: 200,
        iconsTemplate: "font_awesome_5r",
        imageUploadURL: "https://assets.tradeway.com/",
        imageManager: false,
        key: `${process.env.VUE_APP_FROALA_KEY}`,
        linkStyles: {
          'btn': 'Button',
          'btn-blue': 'Blue Button',
          'btn-trans': 'Clear Button',
        },
        paragraphStyles: {
          'border-t pt-2': 'Overline',
          'border-b pb-2': 'Underline'
        },
        toolbarButtons: [
          'fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript',
          '|', 'paragraphStyle', 'paragraphFormat', 'fontFamily', 'fontSize', 'color', // 'inlineStyle', 'paragraphStyle',
          '-', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote',
          '|', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable',
          '-', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting',
          '|', 'print', 'spellChecker', 'help', 'html',
          '|', 'undo', 'redo'],
        tabSpaces: 4,
        videoMaxSize: 1024 * 1024 * 150,
        videoUploadURL: "https://assets.tradeway.com/",
      },
      froalaLoading: true,
      froalaHeroDark: true,
      saving: false
    };
  },
  computed: {
    buttonState() {
      if (this.saving) {
        return [
          "cursor-not-allowed",
          "opacity-50",
          "hover:bg-blue-dark",
          "hover:border-blue-dark"
        ];
      }
      return {};
    },
    saveButtonText() {
      if (this.id) {
        return "Save";
      }
      return "Create";
    },
    ...mapState({
      content: state => state.content,
      navigation: state => state.navigation
    })
  },
  beforeMount() {
    this.$store.dispatch("INIT_CONTENT");
    if (this.id) {
      this.$store.dispatch("LOAD_CONTENT", this.id);
    }
    api.get("/upload-key").then(response => {
      this.config.fileUploadToS3 = response.data;
      this.config.imageUploadToS3 = response.data;
      this.config.videoUploadToS3 = response.data;
      this.froalaLoading = false;
    });
  },
  methods: {
    saveContent() {
      if (!this.saving) {
        this.saving = true;
        this.$store
          .dispatch("SAVE_CONTENT")
          .then(() => this.$router.push("/content"));
      }
    }
  }
};
</script>

<style>
.dark .fr-box.fr-basic .fr-wrapper {
  background: #000;
}
</style>
